import React from 'react';
import { motion } from 'framer-motion';
import services from '../../data/services.json';
import AnimatedGlitch from '../AnimatedGlitch/AnimatedGlitch';

const ServicesRibbon = () => {
    const itemClass = "text-2xl md:text-4xl font-bold text-gray-900 mx-8 whitespace-nowrap uppercase tracking-wider border-0 select-text";

    const renderServiceGroup = (keyPrefix) => (
        services.map((service, index) => (
            <h3
                key={`${keyPrefix}-${index}`}
                className={itemClass}
            >
                {service}
            </h3>
        ))
    );

    return (
        <div className="w-full overflow-x-clip relative z-10 my-8">
            {/* Animated Glitch Effect on right edge - sky blue theme */}
            <div className="absolute left-[-4.5rem] bottom-[0rem] z-10 pointer-events-none" 
                style={{ transform: 'rotate(3.5deg)' }}>
                <AnimatedGlitch
                    width={120}
                    height={120}
                    cellSize={10}
                    speed={420}
                    speedVariance={1.2}
                    density={0.125}
                    persistence={0.75}
                    primaryColor="#38bdf8"
                    secondaryColor="#03111F"
                    tertiaryColor="#38bdf8"
                    quaternaryColor="#03111F"
                />
            </div>
            {/* Animated Glitch Effect on right edge - sky blue theme */}
            <div className="absolute right-[-4rem] bottom-[-2.75rem] z-10 pointer-events-none" 
                style={{ transform: 'rotate(3.5deg)' }}>
                <AnimatedGlitch
                    width={120}
                    height={120}
                    cellSize={10}
                    speed={420}
                    speedVariance={1.2}
                    density={0.35}
                    persistence={0.75}
                    primaryColor="#38bdf8"
                    secondaryColor="#03111F"
                    tertiaryColor="#38bdf8"
                    quaternaryColor="#03111F"
                />
            </div>
            <div
                className="w-full bg-sky-400 border-0 overflow-hidden py-1.5 flex relative shadow-nero"
                style={{ transform: 'rotate(3.5deg)' }}
            >
                <div className="flex select-none">
                    <motion.div
                        className="flex flex-shrink-0"
                        animate={{
                            x: ["0%", "-50%"],
                        }}
                        transition={{
                            repeat: Infinity,
                            ease: "linear",
                            duration: 75, // Adjust speed here
                        }}
                    >
                        {/* Multiple copies for seamless looping */}
                        {renderServiceGroup('loop-1')}
                        {renderServiceGroup('loop-2')}
                        {renderServiceGroup('loop-3')}
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default ServicesRibbon;
